<template>
  <div>
    <h3 v-if="item.historyDeviceStatus === 'MOVING'" class="text-center mb-3">
      Xác nhận điều chuyển thiết bị (Kho xuất)
    </h3>
    <h3 v-else class="text-center mb-3">Xác nhận điều chuyển thiết bị (Kho nhận)</h3>
    <p class="f14 text-center"><span class="f-700">Số phiếu:</span> {{ item.billNumber }}</p>
    <p v-if="item.historyDeviceStatus === 'MOVING'" class="f14 text-center">
      <span class="f-700">Ngày chuyển:</span> {{ item.historyDeviceCreate | formatDate }}
    </p>
    <p v-else class="f14 text-center">
      <span class="f-700">Ngày nhận:</span> {{ item.historyDeviceCreate | formatDate }}
    </p>
    <div class="row mt-4">
      <div class="col-md-8">
        <p class="f14">
          <span class="f-700">Chuyển từ kho:</span>
          {{ item.inventoryNameExport }}
        </p>
        <p class="f14 my-1">
          <span class="f-700">Người duyệt điều chuyển:</span>
          {{ item.personApprove && item.personApprove.name }} -
          {{ item.personApprove && item.personApprove.email }}
        </p>
        <p class="f14 my-1">
          <span class="f-700">Lý do chuyển:</span>
          {{ item.reasonTransfer | transformData(Config.reasonTransferWarehouse) }}
        </p>
        <p class="f14"><span class="f-700">Ghi chú:</span> {{ item.description }}</p>
      </div>
      <div class="col-md-4">
        <p class="f14">
          <span class="f-700">Đến kho:</span>
          {{ item.inventoryNameImport }}
        </p>
      </div>
    </div>
    <div class="p-0 mt-4 card">
      <div
        class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
      >
        <h1 class="mb-1 form-inner-heading f-700">Danh sách thiết bị điều chuyển</h1>
      </div>
      <div class="tab-content">
        <div
          class="table-responsive b-table-sticky-header"
          style="overflow: auto; max-height: 50vh"
        >
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr class="text-center">
                <th>STT</th>
                <th class="text-left">Tên loại thiết bị</th>
                <th>Mã Serial</th>
                <th>DVT</th>
                <th>Tình trạng lúc xuất</th>
                <th v-if="item.historyDeviceStatus !== 'MOVING'">Tình trạng lúc nhận</th>
                <th v-if="item.historyDeviceStatus !== 'MOVING'">Đã nhận</th>
                <th>Ghi chú</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-row text-center"
                v-for="(device, index) in devices"
                :key="`device${index}`"
              >
                <td>{{ index + 1 }}</td>
                <td class="text-left">{{ device.categoryName }}</td>
                <td>{{ device.serial }}</td>
                <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                <td>
                  <span class="badge" :class="[device.type || '']">
                    {{ device.type | transformData(Config.stateDevices) }}
                  </span>
                </td>
                <td v-if="item.historyDeviceStatus !== 'MOVING'">
                  <span class="badge" :class="[device.type || '']">
                    {{ device.type | transformData(Config.stateDevices) }}
                  </span>
                </td>
                <td v-if="item.historyDeviceStatus !== 'MOVING'">
                  <input disabled type="checkbox" :checked="device.isImport" />
                </td>
                <td>{{ device.noteExport }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-header pb-1 pt-4">
        Tổng số thiết bị đã xuất:
        <strong class="text-primary">{{ devices.length }}</strong>
        <div v-if="item.historyDeviceStatus !== 'MOVING'" class="float-right">
          Tổng số thiết bị đã nhận:
          <strong class="text-primary">{{
            devices.filter(s => s.isImport === true).length
          }}</strong>
        </div>
      </div>
      <div class="box-header py-1">
        Mã vận đơn:
        <strong class="text-primary">{{ item.shippingCode }}</strong>
      </div>
      <div class="box-header py-1">
        Đơn vị vận chuyển:
        <strong class="text-primary">{{ item.shippingUnit }}</strong>
      </div>
      <div v-if="item.historyDeviceStatus === 'MOVING'" class="box-header py-1">
        Ghi chú của Kho/ NV xuất:
        <strong class="text-primary">{{ item.noteExport }}</strong>
      </div>
      <div v-else class="box-header py-1">
        Ghi chú của Kho/ NV nhận:
        <strong class="text-primary">{{ item.noteExport }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from '../../../thirdParty/config'

  export default {
    data() {
      return {
        Config,
      }
    },
    props: ['item', 'devices'],
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
  }
</script>
